import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from 'src/app/constants';
import {
  AddUpdateMyReportReqModel,
  AllChartResModel,
  AllChartsReqCommand,
  ChartResp,
  GetGraphReportDocumentRequest,
  GraphFiltersResModel,
  GraphReqModel,
  GraphResModel,
  KPIDashboardTabRep,
  KPIDashboardTileRepoModel,
  KPIDashboardTileReqModel,
  MasterReportRes,
  MyReportListRes,
  MyReportRes,
  PracticeGraphsAndTilesListResponse,
  PrecticeAnalyticsChartReqCommand,
  ReportDocumentModel,
  ReportPushToDashboardModel,
  ReportReqModel,
  ReportSaveModel,
  Response,
  UpdateKPIDashboardTileConfigCommand,
} from 'src/app/models';
import { ApiService } from '../api.service';
import { LocalStorageService } from '../local-storage.service';

const API_REPORT_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class PracticeAnalyticService {
  private api: string = CONTROLLERS.TENANTS.GRAPHS;
  constructor(
    private apiService: ApiService,
    private _localStorageService: LocalStorageService
  ) { }

  getGraph(
    precticeAnalyticsChartReqCommand: PrecticeAnalyticsChartReqCommand
  ): Observable<Response<ChartResp>> {
    return this.apiService.post(
      `${this.api}/${precticeAnalyticsChartReqCommand.id}`,
      precticeAnalyticsChartReqCommand
    );
  }

  getAllGraphs(
    allChartsReqCommand: AllChartsReqCommand
  ): Observable<Response<AllChartResModel>> {
    return this.apiService.post(`${this.api}`, allChartsReqCommand);
  }

  getGraphDetail(
    graphReqModel: GraphReqModel,
    graphType: any
  ): Observable<Response<GraphResModel>> {
    return this.apiService.post(`${this.api + '/' + graphType}`, graphReqModel);
  }

  getGraphExcelData(
    precticeAnalyticsChartReqCommand: PrecticeAnalyticsChartReqCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.GENERATE_GRAPH_EXCEL}/ ${precticeAnalyticsChartReqCommand.id}`,
      precticeAnalyticsChartReqCommand
    )
  }
  getdownoladReport( request: GetGraphReportDocumentRequest): Observable<Response<ReportDocumentModel[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.GET_REPORT_DOCUMENTS}`,
      request
    );
  }

  deleteReportById(id: number): Observable<Response<boolean>> {
    const command = {
      Id: id
    };
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.DELETE_REPORT_DOCUMENT}`,
      command
    )
  }

  getAllFilters(type: number): Observable<Response<GraphFiltersResModel>> {
    return this.apiService.get(`${this.api}/${type}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.GET_All_FILTERS}`);
  }

  // allFilters(id: number) {
  //     let filters = <GraphFiltersResModel>{};
  //     if (this._localStorageService.graphFilters) {
  //         const filter = this._localStorageService.graphFilters.find((x: any) => x.id == id)
  //         if (filter) {
  //             filters = filter.filters;
  //         }
  //         else {
  //             const newFilter = this.getFilters(id);
  //             this._localStorageService.graphFilters.push(newFilter);
  //             filters = newFilter.filters;
  //         }

  //     }
  //     else {
  //         return this.getFilters(id);
  //     }
  // }

  getRelatedGraphs(type: number): Observable<Response<AllChartResModel>> {
    return this.apiService.get(
      `${this.api}/${type}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.GET_RELATED_GRAPHS}`
    );
  }

  getKPIDashboardTiles(
    kpiDashboardTileReqModel: KPIDashboardTileReqModel
  ): Observable<Response<KPIDashboardTileRepoModel>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.PRACTICE_ANALYTICS.GET_KPI_DASHBOARD_TILES}`,
      kpiDashboardTileReqModel
    );
  }

  getMyReport(
    reportReqModel: ReportReqModel
  ): Observable<Response<MyReportListRes>> {
    return this.apiService.post('KPIDashboard/my-report', reportReqModel);
  }

  getMasterReport(): Observable<Response<MasterReportRes>> {
    return this.apiService.get('KPIDashboard/master-report');
  }

  addUpdateMyReport(
    addUpdateMyReportReq: AddUpdateMyReportReqModel
  ): Observable<Response<ReportSaveModel | null>> {
    return this.apiService.post(
      'KPIDashboard/add-update-my-report',
      addUpdateMyReportReq
    );
  }

  getMyReportById(
    reportReqModel: ReportReqModel
  ): Observable<Response<MyReportRes>> {
    return this.apiService.post('KPIDashboard/my-report-by-id', reportReqModel);
  }
  reportPushToDashboard(
    reportPushToDashboardModel: ReportPushToDashboardModel
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      'KPIDashboard/report-push-to-dashboard',
      reportPushToDashboardModel
    );
  }
  getKPIDasboardTab(): Observable<Response<KPIDashboardTabRep>> {
    return this.apiService.post('KPIDashboard/kpi-dashboard-tabs', null);
  }

  updateKPIDashboardTileConfigCommand(body: UpdateKPIDashboardTileConfigCommand): Observable<Response<boolean>> {
    return this.apiService.post(
      'KPIDashboard/update-kpi-dashboard-tile-config',
      body
    );
  }

  getGraphsAndTilesOfPractice(): Observable<Response<PracticeGraphsAndTilesListResponse>> {
    return this.apiService.get(
      'KPIDashboard/get-graphs-and-tiles-of-practice'
    );
  }
}
